import { Injectable } from '@angular/core';
import { ActionTypeDataService } from '../data-services/action-type-data.service';

@Injectable({ providedIn: 'root' })
export class ActionTypeService {

    constructor(
        private actionTypeDataService: ActionTypeDataService
    ) { }

    GetList(): Promise<any> {
        return this.actionTypeDataService.GetList();
    }
    Update(model: any): Promise<any> {
        return this.actionTypeDataService.Update(model);
    }
}